// common/utils/filterUtils.js

const FILTER_STORAGE_KEY = 'tableFilters';

/**
 * Get filters for a specific table
 * @param {string} tableName - Name of the table (e.g., 'jobOpenings', 'candidates')
 * @returns {object|null} - Saved filters or null
 */
export const getTableFilters = (tableName) => {
  try {
    const allFilters = JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY)) || {};
    return allFilters[tableName] || null;
  } catch (error) {
    console.error('Error reading table filters:', error);
    return null;
  }
};

/**
 * Save filters for a specific table
 * @param {string} tableName - Name of the table
 * @param {object} filters - Filter object to save
 */
export const saveTableFilters = (tableName, filters) => {
  try {
    const allFilters = JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY)) || {};
    allFilters[tableName] = filters;
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(allFilters));
  } catch (error) {
    console.error('Error saving table filters:', error);
  }
};

/**
 * Clear filters for a specific table
 * @param {string} tableName - Name of the table
 */
export const clearTableFilters = (tableName) => {
  try {
    const allFilters = JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY)) || {};
    delete allFilters[tableName];
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(allFilters));
  } catch (error) {
    console.error('Error clearing table filters:', error);
  }
};

/**
 * Clear all table filters
 */
export const clearAllTableFilters = () => {
  try {
    localStorage.removeItem(FILTER_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing all table filters:', error);
  }
};

/**
 * Get initial filter state with fallback to saved values
 * @param {string} tableName - Name of the table
 * @param {object} defaultFilters - Default filter values
 * @returns {object} - Filter values
 */
export const getInitialFilterState = (tableName, defaultFilters = {}) => {
  const savedFilters = getTableFilters(tableName);
  return savedFilters || defaultFilters;
};